export default __webpack_public_path__ + "static/media/casperblack.09468400.svg";